// Showroom Map with Location Markers
(function() {
  'use strict';

  function showFallbackImage() {
    const mapContainer = document.getElementById('showroom-map');
    const fallbackContainer = document.getElementById('showroom-map-fallback');

    if (mapContainer) {
      mapContainer.style.display = 'none';
    }

    if (fallbackContainer) {
      fallbackContainer.style.display = 'block';
      console.log('Showing fallback image due to map initialization failure');
    }
  }

  function initShowroomMap() {
    const mapContainer = document.getElementById('showroom-map');
    if (!mapContainer) {
      console.error('Map container not found');
      showFallbackImage();
      return;
    }

    const browseLocationsScript = document.querySelector('.browse-locations-data');
    if (!browseLocationsScript) {
      console.error('Browse locations data not found');
      showFallbackImage();
      return;
    }

    let locationsData;
    try {
      locationsData = JSON.parse(browseLocationsScript.textContent);
    } catch (e) {
      console.error('Error parsing browse locations data:', e);
      showFallbackImage();
      return;
    }

    const locations = Object.values(locationsData);

    if (locations.length === 0) {
      console.error('No locations found');
      showFallbackImage();
      return;
    }

    console.log('locations: ', locations)

    // Calculate the center of all locations and bounds
    const bounds = new google.maps.LatLngBounds();
    const markers = [];

    // Create the map with error handling
    let map;
    try {
      map = new google.maps.Map(mapContainer, {
        zoom: 4,
        center: { lat: 39.8283, lng: -98.5795 }, // Center of USA as default
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        styles: [
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }]
          }
        ]
      });
    } catch (e) {
      console.error('Error creating Google Map:', e);
      showFallbackImage();
      return;
    }

    // Add markers for each location
    locations.forEach((location, index) => {
      const lat = parseFloat(location.latitude);
      const lng = parseFloat(location.longitude);

      // Validate coordinates
      if (isNaN(lat) || isNaN(lng)) {
        console.warn(`Invalid coordinates for location: ${location.title}`);
        return;
      }

      const position = { lat, lng };

      // Determine z-index for stacking order
      let zIndex = 1; // Default for other locations
      if (location.type === 'showroom') {
        zIndex = 3; 
      } else if (location.tooltipText.toLowerCase().includes('retail')) {
        zIndex = 2;
      }

      // Create marker
      const marker = new google.maps.Marker({
        position: position,
        map: map,
        title: location.title,
        animation: google.maps.Animation.DROP,
        zIndex: zIndex,
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 8,
          fillColor: location.type === 'showroom' ? location.tooltipText.toLowerCase().includes('retail') ? '#c66e4e' : '#314438' : '#8dc0d2',
          fillOpacity: 1,
          strokeColor: '#FFFFFF',
          strokeWeight: 2
        }
      });

      // Decode URL-encoded text
      const decodedText = decodeURIComponent(location.text).replace(/\+/g, ' ');

      // Create info window content
      const infoWindowContent = `
        <div style="max-width: 300px; padding: 10px;">
          <h3 style="margin: 0 0 8px 0; font-size: 24px; letter-spacing: calc(24px * -0.03); color: #314438; margin-bottom: 12px;">${location.title}</h3>
          <div class="store-listings-carousel__image-corner-label" data-type="retail" style="z-index: 9; border-radius: 1px; display: flex; padding: 4px 8px; justify-content: center; align-items: center; background: ${location.type === 'showroom' ? location.tooltipText.toLowerCase().includes('retail') ? '#c66e4e' : '#314438' : '#8dc0d2'}; width: fit-content; margin-bottom: 12px; gap: 4px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="10" viewBox="0 0 7 10" fill="none" style="padding: 0; margin-right: 4px;">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 0C1.565 0 0 1.565 0 3.5C0 6.125 3.5 10 3.5 10C3.5 10 7 6.125 7 3.5C7 1.565 5.435 0 3.5 0ZM3.50002 4.74974C2.81002 4.74974 2.25002 4.18975 2.25002 3.49977C2.25002 2.80979 2.81002 2.2498 3.50002 2.2498C4.19002 2.2498 4.75002 2.80979 4.75002 3.49977C4.75002 4.18975 4.19002 4.74974 3.50002 4.74974Z" fill="white"></path>
              </svg>
              <span style="color: var(--primary-white); text-align: center; font-family: var(--font-family-body); font-size: 12px; font-style: normal; font-weight: 700; line-height: 140%; letter-spacing: .6px; text-transform: uppercase;">${location.tooltipText}</span>
          </div>
          <div style="margin-bottom: 24px; font-size: 14px; line-height: 1.5;">
            ${decodedText}
          </div>
          ${location.maps_link ? `
            <a href="${location.maps_link}" target="_blank"
               style="display: inline-block; padding-top: 12px; background: #314438; color: white; text-decoration: none; font-family: var(--font-family-body); letter-spacing: calc(12px * var(--letter-spacing-multipler)); padding-bottom: 12px; font-size: 12px; font-weight: bold; width: 100%; text-align: center;">
              GET DIRECTIONS
            </a>
          ` : ''}
        </div>
      `;

      const infoWindow = new google.maps.InfoWindow({
        content: infoWindowContent
      });

      // Add click listener to show info window
      marker.addListener('click', () => {
        // Close all other info windows
        markers.forEach(m => m.infoWindow.close());
        infoWindow.open(map, marker);
      });

      // Store the info window with the marker
      marker.infoWindow = infoWindow;
      markers.push(marker);

      // Extend bounds to include this marker
      bounds.extend(position);
    });

    // Fit the map to show all markers
    if (markers.length > 0) {
      map.fitBounds(bounds);

      // Add a listener to limit the zoom level after fitBounds
      google.maps.event.addListenerOnce(map, 'bounds_changed', function() {
        const zoom = map.getZoom();
        if (zoom > 15) {
          map.setZoom(15);
        }
      });
    }

    // Add a legend to show marker types
    const legend = document.createElement('div');
    legend.style.cssText = `
      background: white;
      padding: 10px;
      margin: 10px;
      border-radius: 3px;
      box-shadow: 0 2px 6px rgba(0,0,0,0.3);
      font-family: Quicksand, sans-serif;
      font-size: 12px;
    `;
    legend.innerHTML = `
      <div style="margin-bottom: 5px; font-weight: bold;">Locations</div>
      <div style="display: flex; align-items: center; margin-bottom: 3px;">
        <div style="width: 12px; height: 12px; border-radius: 50%; background: #c66e4e;
                    margin-right: 8px; border: 2px solid white;"></div>
        <span>Retail Store</span>
      </div>
      <div style="display: flex; align-items: center; margin-bottom: 3px;">
        <div style="width: 12px; height: 12px; border-radius: 50%; background: #314438;
                    margin-right: 8px; border: 2px solid white;"></div>
        <span>Branch Showroom</span>
      </div>
      <div style="display: flex; align-items: center;">
        <div style="width: 12px; height: 12px; border-radius: 50%; background: #8dc0d2;
                    margin-right: 8px; border: 2px solid white;"></div>
        <span>Partner Store</span>
      </div>
    `;
    map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(legend);
  }

  // Wait for Google Maps API to load
  if (typeof google !== 'undefined' && google.maps) {
    // If already loaded, initialize immediately
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initShowroomMap);
    } else {
      initShowroomMap();
    }
  } else {
    // Wait for the API to load
    window.initShowroomMap = initShowroomMap;
    const checkGoogleMaps = setInterval(() => {
      if (typeof google !== 'undefined' && google.maps) {
        clearInterval(checkGoogleMaps);
        initShowroomMap();
      }
    }, 100);

    // Timeout after 10 seconds - show fallback if API doesn't load
    setTimeout(() => {
      clearInterval(checkGoogleMaps);
      if (typeof google === 'undefined' || !google.maps) {
        console.error('Google Maps API failed to load - showing fallback image');
        showFallbackImage();
      }
    }, 10000);
  }
})();
